// src/pages/PrivacyPolicyLocalized.jsx
// Sert la politique de confidentialité dans la langue de l'utilisateur.
//
// Pourquoi ce wrapper : PrivacyPolicyEN.jsx existait mais n'était routée nulle part
// (constaté le 16/07/2026) — un anglophone lisait donc une politique en français,
// ce qui invalide en pratique le consentement recueilli auprès de lui.
//
// ⚠️ Pas de version DE à ce jour : les locales de l'app incluent l'allemand, mais
// la politique n'existe qu'en FR et EN. Un utilisateur DE reçoit la version FR.
import React from "react";
import { useTranslation } from "react-i18next";
import PrivacyPolicy from "./PrivacyPolicy";
import PrivacyPolicyEN from "./PrivacyPolicyEN";

export default function PrivacyPolicyLocalized() {
  const { i18n } = useTranslation();
  const lang = (i18n.language || "fr").toLowerCase();
  return lang.startsWith("en") ? <PrivacyPolicyEN /> : <PrivacyPolicy />;
}
